import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LumiLogicDashboard from './components/LumiLogicDashboard';
import LumiLogicDashboardDetail from './components/LumiLogicDashboardDetail';
import LumiLogicDataSource from './components/LumiLogicDataSource';

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<LumiLogicDashboard />} />
                <Route path="/dashboard-detail" element={<LumiLogicDashboardDetail />} />
                <Route path="/data-source" element={<LumiLogicDataSource />} />
            </Routes>
        </Router>
    );
}

export default App;